import { render, staticRenderFns } from "./cardWrap.vue?vue&type=template&id=2b4c50bb&scoped=true"
import script from "./cardWrap.vue?vue&type=script&lang=js"
export * from "./cardWrap.vue?vue&type=script&lang=js"
import style0 from "./cardWrap.vue?vue&type=style&index=0&id=2b4c50bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c50bb",
  null
  
)

export default component.exports